import axios from '../utils/request'
import request from 'axios'
import baseUrl from '@/utils/baseUrl';
window.source = request.CancelToken.source();
const api = {
    checkText(data, type, session, endpoint) {
        return axios({
            method: 'post',
            url: `/misscut/v${type}/check_text`,
            data,
            cancelToken: window.source.token,
            headers: {
                session,
                endpoint
            }
        })
    },
    cancelCheck(data) {
        return axios({
            method: 'post',
            url: '/misscut/v1/cancel',
            data
        })
    },
    uploadFile(data) {
        return axios({
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${window.localStorage.getItem('encodedAuth')}`
            },
            url: '/misscut/v1/doc_text',
            data,
        })
    },
    fileList(session) {
        return axios({
            method: 'get',
            url: '/misscut/v1/upload_list',
            headers: {
                session
            }
        })
    },
    getFileDetail(data) {
        return axios({
            method: 'post',
            url: '/misscut/v1/edit_upload_get',
            data,
        })
    },
    resetTips(data) {
        return axios({
            method: 'post',
            url: '/misscut/v1/doc_text_upload_get',
            data
        })
    },
    delFileInfo(data) {
        return axios.delete('/misscut/v1/upload_delete/' + data)
    },
    sendFileInfo(data) {
        return axios.post('/misscut/v1/edit_upload_save', data)
    },
    getUserInfo() {
        return axios.get('/user/v1/user_info')
    },
    editUserName(data) {
        return axios.put('/user/login_id', data)
    },
    editUserPhone(data) {
        return axios.put('/user/phone', data)
    },
    editPassword(data) {
        return axios.put('/user/pwd', data)
    },
    getImage() {
        return axios.get('/user/portrait?' + Date.now(), { responseType: "arraybuffer" })
    },
    getTime(data) {
        return axios.post(
            '/misscut/v1/predict_time',
            data,
        )
    },
    getShareLink(data) {
        return axios.post('/misscut/v1/edit_share', data)
    },
    getShareFile(data) {
        return axios.get(`/misscut/v1/edit_share/${data}`)
    },
    saveShareFile(data) {
        return axios.post('/misscut/v1/share_save', data)
    },
    addWord(data) {
        return axios.post('/dict/v1/add_one', data)
    },
    getWord(data) {
        if (data.search == '') {
            delete data.search
        }
        return axios({
            method: 'GET',
            url: '/dict/v1/get_list',
            params: data
        })
    },
    updateWord(data) {
        return axios.put('/dict/v1/update_one', data)
    },
    deleteWord(data) {
        return axios({
            method: 'DELETE',
            url: '/dict/v1/delete_one',
            params: data
        })
    },
    deleteManyWords(data) {
        return axios({
            method: 'post',
            url: '/dict/v1/delete_many',
            data: data
        })
    },
    getFailWordDetail(params) {
        return axios({
            method: 'get',
            url: '/dict/down_words_failed_to_upload',
            params,
            responseType: "arraybuffer"
        })
    },
    // 官网试用api/component/app/add_one
    gettry(data) {
        // login() {
        return axios({
            url: `/crm/component/app/add_one_checkno`,
            method: 'post',
            data
        })
    },
    // 发送验证码
    sendCode(phone) {
        // login() {
        return axios({
            url: `/crm/component/checkno?phone=${phone}`,
            method: 'get',

        })
    },
    // getUserInfo() {
    //     return axios.get('/user/user_info')
    // },
    // // editUserName(data) {
    // //     return axios.put('/user/login_id',data)
    // // },
    // editUserPhone(data) {
    //     return axios.put('/user/phone', data)
    // },
    // 获取高速通道所剩数量
    getHighSpeedNumber() {
        return axios({
            url: '/misscut/v1/get_user_high_speed_word',
            method: 'get'
        })
    },
    // 注销
    accountCancellation() {
        return axios({
            url: '/user/cancellation',
            method: 'post'
        })
    },
    // 清空词典
    deleteAllWords(data) {
        return axios({
            url: '/dict/v1/delete_all_word',
            method: 'post',
            data
        })
    },
    // chatGPT
    chatGPT(data) {
        return axios({
            url: '/gpt/v1/completion',
            method: 'post',
            data
        })
    },
    getGPTList(data) {
        return axios({
            url: '/gpt/v1/completion/get_list',
            method: 'get',
            params: data
        })
    },

    setValue(data) {
        return axios({
            url: '/gpt/v1/sse/receive_data',
            method: 'post',
            data
        })
    },
    getGPTtoken() {
        return axios({
            url: '/gpt/v1/get_remaining_words',
            method: 'get'
        })
    },
    getPageClick(params) {
        return axios({
            url: '/misscut/v1/click',
            method: 'get',
            params
        })
    },
    checkOpertorCollect(data) {
        return axios({
            url: '/proofread/result/collect/receive',
            method: 'post',
            data
        })
    },
    otherOpertorCollect(data) {
        return axios({
            url: '/proofread/result/collect/delete',
            method: 'post',
            data
        })
    },
    // 停止会话
    closeConversation(data) {
        return axios({
            url: `/gpt/v1/sse/close?uuid=${data}`,
            method: 'get',
            data
        })
    },
    imgCheck(data) {
        return axios({
            url: '/misscut/ocr',
            method: 'post',
            data
        })
    },
    getUserEquity(type) {
        return axios({
            url: `/misscut/v1/get_user_equity?user_equity_type=${type}`,
            method: 'get',
        })
    },
    checkPDF(data, session, endpoint) {
        return axios({
            method: 'post',
            url: `/misscut/v1/pdf_check`,
            data,
            headers: {
                session,
                endpoint
            }
        })
    },
    docDiff(data) {
        return axios({
            method: 'post',
            url: '/misscut/v1/doc/diff',
            data
        })
    },
    getCheckResultsMap() {
        return axios({
            method: 'get',
            url: '/misscut/v1/get_all_mistakes_type',
        })
    },
    exportFile(params) {
        return axios({
            method: 'get',
            url: '/misscut/v1/export_the_proofread_document',
            params,
            responseType: "arraybuffer"
        })
    },
    exportWord(data) {
        return axios({
            method: 'post',
            url: '/misscut/doc_check/v1/html2doc/stream',
            data,
            responseType: "arraybuffer"
        })
    },
    userFeedback(data) {
        return axios({
            url: '/user/leave_message',
            method: 'post',
            data
        })
    },
    docCheck(data, session) {
        return axios({
            url: '/misscut/document/v1/upload',
            method: 'post',
            data,
            headers: {
                session
            }
        })
    },
    getDocList(params, session) {
        return axios({
            url: '/misscut/document/v1/page',
            method: 'get',
            params,
            headers: {
                session
            }
        })
    },
    getDocDetail(params) {
        return axios({
            url: '/misscut/document/v1/edit_upload_get',
            method: 'get',
            params
        })
    },
    deleteDoc(data) {
        return axios({
            url: '/misscut/document/v1/delete',
            method: 'post',
            data
        })
    },
    saveDoc(data) {
        return axios({
            url: '/misscut/document/v1/edit_upload_save',
            method: 'post',
            data
        })
    },
    getDocShareLink(params) {
        return axios({
            url: '/misscut/document/v1/get_share_id',
            method: 'get',
            params
        })
    },
    getShareDoc(params) {
        return axios({
            url: '/misscut/document/v1/get_share_doc',
            method: 'get',
            params
        })
    },
    saveDocToSelf(params) {
        return axios({
            url: '/misscut/document/v1/share_save',
            method: 'get',
            params
        })
    },
    getRecordsList(params, page = 0, limit) {
        return axios({
            url: `/results/sheets/v2/page/list?limit=${limit}&offset=` + page,
            method: 'post',
            data: params
        })
    },
    changeStatus(id, data) {
        return axios({
            url: `/results/sheets/v1/${id}`,
            method: 'put',
            data
        })
    },
    getSnapshot(id) {
        return axios({
            url: `/pages/v1/snapshot/${id}`,
            method: 'get',
            responseType: 'arraybuffer'
        })
    },
    //  getRectifiedNum(params) {
    //     return axios({
    //         url: `/results/sheets/v1/summary/count?${params}`,
    //         method: 'get',
    //     })
    // },
    getRectifiedNum(data) {
        return axios({
            url: `/results/sheets/v2/summary/count`,
            method: 'post',
             data: data
        })
    },
    batchProcess(data) {
        return axios({
            url: '/results/sheets/v1/batch/operate',
            data,
            method: 'post',
            responseType: data.opt == 'export' ? 'arraybuffer' : ''
        })
    },
    // exportResult(params, type) {
    //     return axios({
    //         url: '/results/sheets/v1/export/list?doc_type=' + type + params,
    //         method: 'get',
    //         responseType: 'arraybuffer'
    //     })
    // },
    exportResult(params, type) {
        return axios({
            url: '/results/sheets/v2/export/list?doc_type=' + type,
            method: 'post',
            responseType: 'arraybuffer',
            data: params
        })
    },
    getSearchList(params) {
        return axios({
            url: '/results/sheets/v1/const/list',
            method: 'get',
            params
        })
    },
    getErrorTypeList(params) {
        return axios({
            url: '/results/sheets/v1/const/enum',
            method: 'get',
            params
        })
    },
    getHomeColumnList(params) {
        return axios({
            url: '/page/renew/v1',
            params,
            method: 'get'
        })
    },
    getWebList() {
        return axios({
            url: '/tasks/v1/task/list',
            method: 'get',
        })
    },
    saveColumnUpdate(data) {
        return axios({
            url: '/page/renew/v1',
            data,
            method: 'post'
        })
    },
    batchColumnProcess(data) {
        return axios({
            url: '/page/renew/v1/batch/operate',
            data,
            method: 'post'
        })
    },
    getIndexColumnNumber(type) {
        return axios({
            url: `/page/renew/v1/statistic/dashboard?query=[page_renew_type:=:${type}]`,
            method: 'get'
        })
    },
    getErrorSensitiveNumber() {
        return axios({
            url: `/results/sheets/v1/statistic/dashboard?query=[result_sheet_status:=:0]`,
            method: 'get'
        })
    },
    getIndexConnectNumber() {
        return axios({
            url: '/page/renew/v1/homepage/accessible',
            method: 'get'
        })
    },
    getLeaderList(params) {
        return axios({
            url: '/dict/v1/leader/list',
            method: 'get',
            params
        })
    },
    handleLeader(data) {
        return axios({
            url: '/dict/v1/leader/add',
            method: 'post',
            data
        })
    },
    updateLeader(id, data) {
        return axios({
            url: `/dict/v1/leader/update/${id}`,
            method: 'put',
            data
        })
    },
    batchLeader(data) {
        return axios({
            url: '/dict/v1/leader/batch',
            method: 'post',
            data
        })
    },
    sortLeader(data) {
        return axios({
            url: '/dict/v1/leader/sort',
            method: 'post',
            data
        })
    },
    editAlert(data, id) {
        return axios({
            url: '/alarm/v1/' + id,
            method: 'put',
            data
        })
    },
    getAlarmInfo() {
        return axios({
            url: '/alarm/v1/',
            method: 'get'
        })
    },
    getAlarmList(params) {
        return axios({
            url: '/alarm/data',
            method: 'get',
            params,
            responseType: params.mode ? 'arraybuffer' : ''
        })
    },
    getAlramSnap(id) {
        return axios({
            url: '/alarm/snapshot/' + id,
            method: 'get',
            responseType: 'arraybuffer'
        })
    },
    getSnapshotForHTML(id, type = 0) {
        return axios({
            url: `/pages/v1/info/${id}?page_type=${type}`,
            method: 'get'
        })
    },
    getKeysList(params, data) {
        return axios({
            url: '/pages/v1/search/term',
            params,
            method: 'post',
            data
        })
    },
    getFollowStatus() {
        return axios({
            url: '/alarm/get_fwh_interested_status',
            method: 'get'
        })
    },
    getWxCode() {
        return axios({
            url: '/alarm/get_fwh_qrcode',
            method: 'get',
            responseType: 'arraybuffer'
        })
    }
}

export default api
